import { render, staticRenderFns } from "./onboardingLayout.vue?vue&type=template&id=58a086c9&"
import script from "./onboardingLayout.vue?vue&type=script&lang=js&"
export * from "./onboardingLayout.vue?vue&type=script&lang=js&"
import style0 from "./onboardingLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports